import { User as Auth0User } from '@auth0/auth0-react'

export const isSimAdmin = (user?: Auth0User) =>
  user?.[`${process.env.AUTH0_NAMESPACE}/roles`].indexOf('sim-admin') !== -1
